import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaUserCircle, FaEdit } from "react-icons/fa";

const ProfilePage = () => {
    const navigate = useNavigate();

    useEffect(() => {
        console.log("hello : " + localStorage.getItem(""));
    }, []);

    const customerType = localStorage.getItem("CustomerType");
    const LedName = localStorage.getItem("LedName");
    const AgentCode = localStorage.getItem("AgentCode");
    const Ledcode = localStorage.getItem("Ledcode");

    const user = {
        name: customerType,
        LedName: LedName,
        AgentCode: AgentCode,
        Ledcode: Ledcode,
        email: "email@example.com",
        phone: "+91 9876543210",
        address: "Perinthalmanna, Malappuram",
        joined: "July 2025",
        profilePic: "",
    };

    const handleEdit = () => {
        alert("Edit profile ");
    };

    const handleLogout = () => {
        alert("Log out");
        navigate("/");
    };

    return (
        <div className="min-h-screen flex items-center justify-center p-4" style={{ backgroundColor: "#F3F4F6" }}>
            <div className="w-full max-w-3xl rounded-lg shadow-lg p-6" style={{ backgroundColor: "#FFFFFF" }}>
                {/* Header */}
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
                    <div className="flex items-center gap-4">
                        {user.profilePic ? (
                            <img src={user.profilePic} alt="Profile" className="w-20 h-20 rounded-full object-cover" />
                        ) : (
                            <FaUserCircle className="w-20 h-20 text-[#9CA3AF]" />
                        )}
                        <div>
                            <h2 className="text-xl font-semibold">{user.name}</h2>
                            <p className="text-sm text-[#6B7280]">{user.email}</p>
                        </div>
                    </div>
                    <div className="mt-4 sm:mt-0 flex gap-3">
                        <button
                            onClick={handleEdit}
                            className="flex items-center gap-1 px-4 py-2 rounded text-[white] bg-[#2563EB]"
                        >
                            <FaEdit />
                            Edit Profile
                        </button>
                        <button onClick={handleLogout} className="px-4 py-2 rounded text-[white] bg-[#EF4444]">
                            Logout
                        </button>
                    </div>
                </div>

                <hr className="my-6" />

                {/* Info Section */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 text-sm">
                    <div>
                        <p className="font-medium text-[#6B7280]">Phone</p>
                        <p className="text-[#1F2937]">{user.phone}</p>
                    </div>
                    <div>
                        <p className="font-medium text-[#6B7280]"> Address</p>
                        <p className="text-[#1F2937]">{user.address}</p>
                    </div>
                    <div>
                        <p className="font-medium text-[#6B7280]"> Joined</p>
                        <p className="text-[#1F2937]">{user.joined}</p>
                    </div>
                    <div>
                        <p className="font-medium text-[#6B7280]"> Le Name</p>
                        <p className="text-[#1F2937]">{user.LedName}</p>
                    </div>
                    <div>
                        <p className="font-medium text-[#6B7280]"> Le Code</p>
                        <p className="text-[#1F2937]">{user.Ledcode}</p>
                    </div>
                    <div>
                        <p className="font-medium text-[#6B7280]"> A Code</p>
                        <p className="text-[#1F2937]">{user.AgentCode}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProfilePage;
